import * as React                    from 'react'
import { FormattedMessage }          from 'react-intl'
import { connect }                   from 'react-redux'
import { Link, RouteComponentProps } from 'react-router-dom'

import Button                              from '@material-ui/core/Button/Button'
import Card                                from '@material-ui/core/Card/Card'
import CardActions                         from '@material-ui/core/CardActions/CardActions'
import CardContent                         from '@material-ui/core/CardContent/CardContent'
import CardHeader                          from '@material-ui/core/CardHeader/CardHeader'
import { InjectedFormikProps, withFormik } from 'formik'
import { object, ref }                     from 'yup'

import { ApplicationState, resetPasswordRequest }                   from '../../redux/ducks'
import { ActionButton, InlineError, LoadingOverlay, PasswordField } from '../atoms'
import { i18nErrorCodes, mapFormikToMuiProps }                      from '../forms/form-utils'
import { passwordSchema }                                           from '../forms/schemas/formatSchemas'

const mstp = (state: ApplicationState) =>
  ({ resetPasswordCommunication: resetPasswordRequest.communicationSelector(state) })

const actions = { resetPassword: resetPasswordRequest.actionCreator }

type ReduxProps =
  ReturnType<typeof mstp>
  & typeof actions

interface ForgotPasswordFields {
  password: string
  passwordConfirmation: string
}

type PassedProps =
  ReduxProps
  & RouteComponentProps<{ token: string }>

type Props = InjectedFormikProps<PassedProps, ForgotPasswordFields>

class ForgotPassword extends React.Component<Props> {
  public componentDidUpdate (lastProps: Props) {
    if (
      lastProps.resetPasswordCommunication.fetching
      && this.props.resetPasswordCommunication.success
    ) {
      this.props.history.replace('/')
    }
  }

  public render () {

    const phrasing = {
      resetPassword:       <FormattedMessage id={'forms.resetPassword'} />,
      resetPasswordPrompt: <FormattedMessage id={'forms.resetPasswordPrompt'} />,
    }

    const mapper = mapFormikToMuiProps(this.props as any)

    const { resetPasswordCommunication: { error, fetching } } = this.props

    return (
      <Card style={{ minWidth: 400 }}>
        <LoadingOverlay show={fetching}>
          <CardHeader
            title={phrasing.resetPassword}
            subheader={phrasing.resetPasswordPrompt}
          />
          <form onSubmit={this.props.handleSubmit}>
            <CardContent>
              <PasswordField
                autoFocus
                fullWidth
                margin={'dense'}
                {...mapper('password')}
              />
              <PasswordField
                fullWidth
                margin={'dense'}
                {...mapper('passwordConfirmation')}
              />
            </CardContent>
            {error && (
              <CardContent>
                <InlineError i18nErrorId={error} />
              </CardContent>
            )}
            <CardActions>
              <ActionButton
                variant={'raised'}
                type={'submit'}
                actionType={'submit'}
                color={'primary'}
              />
              <Link to={''}>
                <Button color={'primary'}>
                  <FormattedMessage id={'buttonActions.backToLogin'} />
                </Button>
              </Link>
            </CardActions>
          </form>
        </LoadingOverlay>
      </Card>
    )
  }
}

export default connect(mstp, actions)(withFormik<PassedProps, ForgotPasswordFields>({
  validationSchema: object().shape({
    password:             passwordSchema.required(i18nErrorCodes.required),
    passwordConfirmation: passwordSchema
                            .oneOf([ ref('password') ], i18nErrorCodes.mustBeIdentical)
                            .required(i18nErrorCodes.required),
  }),

  mapPropsToValues: () => ({
    password:             '',
    passwordConfirmation: '',
  }),

  handleSubmit: (values, bag) => {
    const { password } = values
    const { token } = bag.props.match.params

    bag.props.resetPassword({
      password,
      token,
    })
  },
})(ForgotPassword))



// WEBPACK FOOTER //
// ./src/components/organisms/ResetPassword.tsx